module.exports = __webpack_public_path__ + "static/img/cont43_08.a404642.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_08.jpg
// module id = fuPt
// module chunks = 0